import AdWords from './adwords'
import search from './search/search-routing'
import detail from './detail/detail-routing'

export default [{
    path: '/adwords',
    name:'adwords',
    component:AdWords,
    children:[
        ...search,
        ...detail
    ]
}]